export { OrientationLock, unsetScreenLock } from './OrientationLock';